module.exports = __webpack_public_path__ + "img/2.d4ca4874.gif";